import React, { useRef } from 'react';
import S from './Quantity.styles';
import { ReactComponent as Minus } from '@img/icons/minus.svg';
import { ReactComponent as Plus } from '@img/icons/plus.svg';
import debounce from 'lodash/debounce';
import Label from '../Label/Label.styles';
const Quantity = (props) => {
    const max = props.max !== undefined ? props.max : 999;
    const min = props.min !== undefined ? props.min : 1;
    const debouncedChanged = useRef(debounce((value) => {
        if (!props.onDebouncedChange) {
            return;
        }
        props.onDebouncedChange(value);
    }, 500));
    const handleButton = (direction) => {
        if (!props.onChange) {
            return;
        }
        let newValue = props.value;
        if (direction === 'plus') {
            newValue += 1;
        }
        else if (direction === 'minus') {
            newValue -= 1;
        }
        props.onChange && props.onChange(newValue);
        debouncedChanged.current(newValue);
    };
    return (React.createElement(S.Wrapper, null,
        props.label && React.createElement(Label, null, props.label),
        React.createElement(S.Element, null,
            React.createElement(S.Button, { onClick: () => handleButton('minus'), disabled: props.value === min },
                React.createElement(Minus, null)),
            React.createElement(S.Input, { value: props.value, onChange: (event) => {
                    const val = parseInt(event.target.value.replace(/\D/g, ''));
                    const newValue = isNaN(val) ? min : val;
                    props.onChange && props.onChange(newValue);
                    debouncedChanged.current(newValue);
                }, min: min, max: max, maxLength: 3 }),
            React.createElement(S.Button, { onClick: () => handleButton('plus'), disabled: props.value === max },
                React.createElement(Plus, null)))));
};
export default Quantity;
